export default function (props: any) {
    return (
        <svg
            {...props}
            width="46px"
            height="52px"
            viewBox="0 0 46 52"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <rect id="path-1" x="0" y="0" width="46" height="52"></rect>
            </defs>
            <g id="通用产品预览页" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="通用产品预览页--Solutions" transform="translate(-721.000000, -111.000000)">
                    <g id="编组-4" transform="translate(478.000000, 111.000000)">
                        <g id="编组-8" transform="translate(223.000000, 0.000000)">
                            <g id="导航栏Components" transform="translate(20.000000, 0.000000)">
                                <mask id="mask-2" fill="white">
                                    <use xlinkHref="#path-1"></use>
                                </mask>
                                <g id="矩形"></g>
                                <g id="Frame" mask="url(#mask-2)">
                                    <g transform="translate(1.000000, 9.000000)">
                                        <rect id="矩形" stroke="#000000" strokeWidth="1.5" fill="none" x="8.5" y="0" width="27" height="15" rx="3"></rect>
                                        <line
                                            x1="22"
                                            y1="17"
                                            x2="22"
                                            y2="24.5"
                                            id="路径"
                                            stroke="#000000"
                                            strokeWidth="1.5"
                                            fill="none"
                                            strokeLinecap="square"
                                            strokeLinejoin="round"
                                        ></line>
                                        <rect
                                            id="矩形"
                                            stroke="#000000"
                                            strokeWidth="1.66666667"
                                            fill="none"
                                            x="0"
                                            y="25"
                                            width="13"
                                            height="10"
                                            rx="2.22222222"
                                        ></rect>
                                        <path
                                            d="M11,15 L17,15 L17,16.5 C17,16.7761424 16.7761424,17 16.5,17 L11.5,17 C11.2238576,17 11,16.7761424 11,16.5 L11,15 L11,15 Z"
                                            id="矩形"
                                            stroke="none"
                                            fill="#000000"
                                            fillRule="evenodd"
                                        ></path>
                                        <path
                                            d="M19,15 L25,15 L25,16.5 C25,16.7761424 24.7761424,17 24.5,17 L19.5,17 C19.2238576,17 19,16.7761424 19,16.5 L19,15 L19,15 Z"
                                            id="矩形"
                                            stroke="none"
                                            fill="#000000"
                                            fillRule="evenodd"
                                        ></path>
                                        <path
                                            d="M27,15 L33,15 L33,16.5 C33,16.7761424 32.7761424,17 32.5,17 L27.5,17 C27.2238576,17 27,16.7761424 27,16.5 L27,15 L27,15 Z"
                                            id="矩形"
                                            stroke="none"
                                            fill="#000000"
                                            fillRule="evenodd"
                                        ></path>
                                        <rect
                                            id="矩形"
                                            stroke="#000000"
                                            strokeWidth="1.66666667"
                                            fill="none"
                                            x="15.5"
                                            y="25"
                                            width="13"
                                            height="10"
                                            rx="2.22222222"
                                        ></rect>
                                        <rect
                                            id="矩形"
                                            stroke="#000000"
                                            strokeWidth="1.66666667"
                                            fill="none"
                                            x="31"
                                            y="25"
                                            width="13"
                                            height="10"
                                            rx="2.22222222"
                                        ></rect>
                                        <path
                                            d="M30,17 C30,18.6248971 31.3172394,19.9421365 32.9421365,19.9421365 L34.7331936,19.9421365 C36.3900479,19.9421365 37.7331936,21.2852822 37.7331936,22.9421365 L37.7331936,24 L37.7331936,24"
                                            id="路径-2"
                                            stroke="#000000"
                                            strokeWidth="1.5"
                                            fill="none"
                                            strokeLinecap="square"
                                            strokeLinejoin="round"
                                        ></path>
                                        <path
                                            d="M6,17 C6,18.6248971 7.31723938,19.9421365 8.94213649,19.9421365 L11,19.9421365 C12.6568542,19.9421365 14,21.2852822 14,22.9421365 L14,24 L14,24"
                                            id="路径-2"
                                            stroke="#000000"
                                            strokeWidth="1.5"
                                            fill="none"
                                            strokeLinecap="square"
                                            strokeLinejoin="round"
                                            transform="translate(10.000000, 20.500000) scale(-1, 1) translate(-10.000000, -20.500000) "
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
